export default __webpack_public_path__ + "static/media/justpayto-philippines-payments-3.ff2850b6.jpg";